import {
  LocationGroupType,
  UserSelectionInput,
  UserSelectionSetInput,
} from "@src/types.generated";
import { UserSelectionFilterType } from "./SelectUsersDialog";
import { camelCase, startCase } from "lodash";
import { ContentType } from "@src/features/contentLibrary/ContentAvatar";
import {
  AutomationItem,
  AutomationContentType,
} from "@src/features/sidebars/shared/constants";
import { isUserSelectionInputEmpty } from "@src/features/contentLibrary/utils/assignments";

export const isLocationGroupType = (
  filter: UserSelectionFilterType,
): boolean => {
  return (
    filter === LocationGroupType.Region ||
    filter === LocationGroupType.Brand ||
    filter === LocationGroupType.Franchise
  );
};

export const toCamelCase = (text: string): string => {
  return startCase(camelCase(text));
};

export const getEmptyUserSelectionInput = (): UserSelectionInput => {
  return {
    allLocations: false,
    locationGroupIds: [],
    locationIds: [],
    roleIds: [],
    allManagers: false,
    allAdmins: false,
    allTrainees: false,
  };
};

export const getContentIdFromAutomationItem = (
  automationItem: AutomationItem,
): string | number => {
  if (automationItem.automation.libraryItem?.module?.id) {
    return automationItem.automation.libraryItem?.module?.id;
  } else if (automationItem.automation.libraryItem?.course?.id) {
    return automationItem.automation.libraryItem?.course?.id;
  } else if (automationItem.automation.libraryItem?.trainingResource?.id) {
    return automationItem.automation.libraryItem?.trainingResource?.id;
  } else {
    return -1;
  }
};

export const getAutomationItemContentType = (
  automationItemType: AutomationContentType,
): ContentType => {
  if (automationItemType === "Course") {
    return "Course";
  } else if (automationItemType === "TrainingResource") {
    return "Resource";
  } else {
    return "Module";
  }
};

export const formatSentenceList = (
  list: string[],
  conjunction: "and" | "or",
): string => {
  if (list.length === 0) {
    return "";
  } else if (list.length === 1) {
    return list[0];
  } else {
    const lastItem = list.pop();
    return `${list.join(", ")} ${conjunction} ${lastItem}`;
  }
};

export const isUserSelectionSetInputEmpty = (
  userSelectionSetInput: UserSelectionSetInput,
): boolean => {
  if (!userSelectionSetInput) return true;
  if (userSelectionSetInput.userSelections.length === 0) return true;
  return userSelectionSetInput.userSelections.every(isUserSelectionInputEmpty);
};

export const getEveryoneAtOrgOrBrandAudience = (
  orgName: string,
  brands: { name: string }[],
): string => {
  if (brands.length === 0) return orgName;
  if (brands.length === 1) return brands[0].name;
  if (brands.length === 2) return `${brands[0].name} and ${brands[1].name}`;
  const names = brands.map((brand) => brand.name);
  const lastBrand = names.pop();
  return `${names.join(", ")}, and ${lastBrand}`;
};

export const getEveryoneAtOrgOrBrandLabel = (
  orgName: string,
  brands: { name: string }[],
): string => `Everyone at ${getEveryoneAtOrgOrBrandAudience(orgName, brands)}`;

export const getSendToEveryoneAtOrgOrBrandLabel = (
  orgName: string,
  brands: { name: string }[],
): string =>
  `Send to everyone at ${getEveryoneAtOrgOrBrandAudience(orgName, brands)}`;
